
export const reviewsData = [
  {
    id: 1,
    name: 'Michael Thompson',
    rating: 5,
    date: '2024-01-15',
    service: 'Roofing',
    text: 'Spyder Restoration did an amazing job on our roof! They handled everything with our insurance company and we didn\'t pay a dime out of pocket. The crew was professional, efficient, and cleaned up perfectly. Highly recommend!',
    avatar: 'https://ui-avatars.com/api/?name=Michael+Thompson&background=00D9FF&color=fff'
  },
  {
    id: 2,
    name: 'Sarah Martinez',
    rating: 5,
    date: '2024-01-10',
    service: 'Siding',
    text: 'Our home looks brand new! The siding installation was flawless and the team was incredibly respectful of our property. They worked with our insurance claim and made the whole process stress-free. Best decision we made!',
    avatar: 'https://ui-avatars.com/api/?name=Sarah+Martinez&background=00D9FF&color=fff'
  },
  {
    id: 3,
    name: 'David Johnson',
    rating: 5,
    date: '2024-01-05',
    service: 'Storm Damage',
    text: 'After the storm damaged our roof, Spyder Restoration responded immediately. They put up a tarp the same day and handled all the insurance paperwork. The restoration was completed quickly and looks perfect. True professionals!',
    avatar: 'https://ui-avatars.com/api/?name=David+Johnson&background=00D9FF&color=fff'
  },
  {
    id: 4,
    name: 'Jennifer Williams',
    rating: 5,
    date: '2023-12-28',
    service: 'Gutters',
    text: 'The seamless gutters and gutter guards they installed are fantastic! No more clogged gutters or water issues. The crew was punctual, professional, and the price was very fair. Excellent service from start to finish!',
    avatar: 'https://ui-avatars.com/api/?name=Jennifer+Williams&background=00D9FF&color=fff'
  },
  {
    id: 5,
    name: 'Robert Anderson',
    rating: 5,
    date: '2023-12-20',
    service: 'Roofing',
    text: 'Outstanding work! They replaced our entire roof using GAF materials and it looks incredible. The insurance claim process was handled seamlessly by their team. I\'ve already recommended them to three neighbors!',
    avatar: 'https://ui-avatars.com/api/?name=Robert+Anderson&background=00D9FF&color=fff'
  },
  {
    id: 6,
    name: 'Lisa Brown',
    rating: 5,
    date: '2023-12-15',
    service: 'Windows',
    text: 'Our new windows have made such a difference in our energy bills! The installation was quick and clean. The team was knowledgeable and helped us choose the perfect windows for our home. Very satisfied!',
    avatar: 'https://ui-avatars.com/api/?name=Lisa+Brown&background=00D9FF&color=fff'
  },
  {
    id: 7,
    name: 'James Miller',
    rating: 5,
    date: '2023-12-10',
    service: 'Siding',
    text: 'Spyder Restoration transformed our home with beautiful James Hardie siding. They worked directly with our insurance company after hail damage and we paid nothing. The quality of work is exceptional!',
    avatar: 'https://ui-avatars.com/api/?name=James+Miller&background=00D9FF&color=fff'
  },
  {
    id: 8,
    name: 'Amanda Davis',
    rating: 5,
    date: '2023-12-05',
    service: 'Roofing',
    text: 'From the initial inspection to the final cleanup, everything was perfect. They explained the insurance process clearly and handled everything. Our new CertainTeed roof looks amazing and we have a lifetime warranty!',
    avatar: 'https://ui-avatars.com/api/?name=Amanda+Davis&background=00D9FF&color=fff'
  },
  {
    id: 9,
    name: 'Carlos Rodriguez',
    rating: 5,
    date: '2024-01-18',
    service: 'Storm Damage',
    text: 'When a massive storm hit Elkhart, Spyder was at my door the next morning. They documented everything for insurance, got my claim approved fast, and the new roof is better than the original. These guys are the real deal!',
    avatar: 'https://ui-avatars.com/api/?name=Carlos+Rodriguez&background=00D9FF&color=fff'
  },
  {
    id: 10,
    name: 'Patricia Nelson',
    rating: 5,
    date: '2024-01-20',
    service: 'Roofing',
    text: 'I got quotes from 5 different companies and Spyder was the most professional by far. They didn\'t pressure me, explained everything in detail, and delivered exactly what they promised. My neighbors keep asking who did my roof!',
    avatar: 'https://ui-avatars.com/api/?name=Patricia+Nelson&background=00D9FF&color=fff'
  },
  {
    id: 11,
    name: 'Kevin O\'Brien',
    rating: 5,
    date: '2024-01-22',
    service: 'Gutters',
    text: 'Finally no more ice dams! The heated gutter system Spyder installed has been a game changer for our Indiana winters. Professional installation, fair pricing, and they cleaned up like they were never here. A+ service!',
    avatar: 'https://ui-avatars.com/api/?name=Kevin+OBrien&background=00D9FF&color=fff'
  },
  {
    id: 12,
    name: 'Maria Gonzalez',
    rating: 5,
    date: '2024-01-25',
    service: 'Siding',
    text: 'Rocael and his team are incredible! They replaced all our siding after hail damage and our house looks like a model home now. The insurance process was completely handled by them - zero stress for us. Highly recommend!',
    avatar: 'https://ui-avatars.com/api/?name=Maria+Gonzalez&background=00D9FF&color=fff'
  },
  {
    id: 13,
    name: 'Thomas Wright',
    rating: 5,
    date: '2024-01-28',
    service: 'Windows',
    text: 'Best investment we\'ve made in our home! The energy-efficient windows Spyder installed have cut our heating bills by 30%. The crew was respectful, on time, and the quality is outstanding. Will use them again for our roof!',
    avatar: 'https://ui-avatars.com/api/?name=Thomas+Wright&background=00D9FF&color=fff'
  },
  {
    id: 14,
    name: 'Rebecca Foster',
    rating: 5,
    date: '2024-02-01',
    service: 'Roofing',
    text: 'After getting the runaround from other contractors, Spyder Restoration was a breath of fresh air. Honest, transparent pricing, beautiful workmanship, and they actually showed up when they said they would. This is how business should be done!',
    avatar: 'https://ui-avatars.com/api/?name=Rebecca+Foster&background=00D9FF&color=fff'
  }
];
